import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { debounce } from "lodash";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import NonIdealState from "../../components/NonIdealState";
import Moment from "../../components/Moment";
import { emailsList } from "../../actions";
import styles from "./ClientDashboardPage.module.css";
import { history } from "../../history";

const identity = (data) => data;

export class ClientDashboardPage extends Component {
  constructor(props) {
    super(props);
    this.searchRef = createRef();
  }

  componentWillMount() {
    this.props.emailsList(
      this.props.match.params.accountId,
      {
        limit: 12,
      },
      true
    );
    this.renderEmail = this.renderEmail.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.search = debounce(this.search.bind(this), 500);
  }

  componentDidMount() {
    if (this.searchRef?.current) {
      this.searchRef.current.focus();
    }
  }

  onSearch(e) {
    const searchTerm = e.currentTarget.value;
    this.search(searchTerm);
  }

  search(searchTerm) {
    history.push(
      `${window.location.pathname}/campaigns?name=${encodeURIComponent(
        searchTerm
      )}`
    );
  }

  renderEmail(email) {
    const { accountId } = this.props.match.params;
    const { id, updatedAt, campaignId, Campaign } = email;

    return (
      <div key={id} className={styles.column}>
        <Link to={`/clients/${accountId}/campaigns/${campaignId}`}>
          <div className={styles.campaign}>
            <div className={styles.preview}>
              <img
                src={`${process.env.REACT_APP_API_ENDPOINT}/api/clients/${accountId}/emails/${id}/image?updatedAt=${updatedAt}`}
                alt=""
              />
            </div>
            <div className={styles.name}>{Campaign && Campaign.name}</div>
            <div>
              <Moment date={updatedAt} />
            </div>
          </div>
        </Link>
      </div>
    );
  }

  render() {
    const { accountId } = this.props.match.params;
    const { emails, clients, isFetching } = this.props;
    const client = clients && clients.find((client) => client.id === accountId);

    return (
      <div style={{ padding: 20 }}>
        <Helmet>
          <title>{`Mercury - ${client?.name}`}</title>
        </Helmet>
        <div className={styles.search}>
          <input
            ref={this.searchRef}
            placeholder={`Search ${client?.name}`}
            onChange={this.onSearch}
          />
        </div>
        <h1>Recent campaigns</h1>
        <br />
        {emails.length > 0 ? (
          emails.map(this.renderEmail)
        ) : !isFetching ? (
          <NonIdealState title="No Emails Found" visual="warning" />
        ) : (
          <NonIdealState title="Loading" visual="refresh" spin />
        )}
      </div>
    );
  }
}

ClientDashboardPage.propTypes = {
  emailsList: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.object.isRequired,
  }),
  emails: PropTypes.array.isRequired,
  clients: PropTypes.array,
};

// Connect state data
function mapStateToProps(state) {
  const clients = state.auth.identity.access;
  const emailsPagination = state.pagination.emails || {};
  const emails = (emailsPagination.ids || [])
    .map((id) => state.entities.email[id])
    .filter(identity);
  const isFetching = emailsPagination.isFetching;

  return {
    emails,
    isFetching,
    clients,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  emailsList,
})(ClientDashboardPage);
